import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { reduce } from 'lodash';
import { getQuestionCategories } from '../thunks/question-thunks';

export const useQuestionCategories = () => {
  const dispatch = useDispatch();
  const { categories } = useSelector((state: RootStateOrAny) => state.question);
  const [categoriesMap, setCategoriesMap] = useState<{ [key: string]: boolean }>({});

  useEffect(() => {
    dispatch(getQuestionCategories());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setCategoriesMap(
      reduce(
        categories.hits,
        (acc: any, category) => {
          acc[category.id] = category.name;
          return acc;
        },
        {}
      )
    );
  }, [categories]);

  return { categories, categoriesMap };
};
